import axios from "axios";
import {
  ItemSearchOptions,
  PublicItemDetailModel,
  PublicItemListModel,
} from "models";
import { IAPIResult } from "models/interfaces";
import { Utils } from "utils";

export async function search(options: ItemSearchOptions) {
  await Utils.sleep(300);

  // await Utils.sleep(300);
  const response = await axios.post<IAPIResult<PublicItemListModel>>(
    "/api.d/v1/ec/item/public-search",
    options
  );

  return response.data;
}

export async function detail(item_cd: string) {
  const response = await axios.get<IAPIResult<PublicItemDetailModel>>(
    "/api.d/v1/ec/item/public-detail",
    { params: { item_cd } }
  );

  return response.data;
}

export async function downloadPDF(item_cd: string) {
  const response = await axios.post<BlobPart>(
    "/api.d/v1/ec/item/pdf-download",
    { item_cd },
    {
      responseType: "blob",
    }
  );
  return response.data;
}
